import { render, staticRenderFns } from "./DiagSupported.vue?vue&type=template&id=4bb4ffd0&"
import script from "./DiagSupported.vue?vue&type=script&lang=js&"
export * from "./DiagSupported.vue?vue&type=script&lang=js&"
import style0 from "./DiagSupported.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports